export default __webpack_public_path__ + "static/media/cmc-inactive.586f0323.svg";